import types from '../../constants';

export function changeVariableInput(variable, value) {
  return async (dispatch) => {
    dispatch({
      type: types.EXERCISE_VARIABLES_CHANGE_VARIABLE_INPUT,
      payload: { key: variable, value },
    });
    if(typeof value === 'boolean') {
      global.socket.emit('set_var', { key: variable, value }); 
    }
  };
}

export function submitVariable(variable, value) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_VARIABLES_LOADING_START });
    global.socket.emit('set_var', { key: variable, value });
  };
}

export function copyVariables(variables) {
  return {
    type: types.EXERCISE_VARIABLES_COPY_VARIABLES,
    payload: variables,
  };
}

export function changeNewVariableKey(value) {
  return {
    type: types.EXERCISE_VARIABLES_CHANGE_NEW_VARIABLE_KEY,
    payload: value,
  };
}

export function changeNewVariableValue(value) {
  return {
    type: types.EXERCISE_VARIABLES_CHANGE_NEW_VARIABLE_VALUE,
    payload: value,
  };
}
